import React from "react";

import { useTheme } from "../../../../../context/theme";
import { Position, ResponsiveProp } from "../../../../../types";
import colorWithOpacity from "../../../../../utils/colorWithOpacity";
import { Box } from "../../../../layout";

type Props = {
  position: ResponsiveProp<Position>;
  onCloseClick?: () => void;
};

export default function Overlay({ position, onCloseClick }: Props) {
  const theme = useTheme();

  return (
    <Box
      position={position}
      top="0"
      left="0"
      height="100%"
      width="100%"
      onClick={onCloseClick}
      backgroundColor={colorWithOpacity(theme["modal-overlay"], 0.6)}
      cursor={onCloseClick ? "pointer" : "default"}
    />
  );
}
